"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortalSdk = exports.ClientTypeList = exports.TrackingEventList = void 0;
const graphql_request_1 = require("graphql-request");
const cookies_1 = require("./cookies");
const sdk_1 = require("./sdk");
var TrackingEventList;
(function (TrackingEventList) {
    TrackingEventList["CHECKOUT_FREE"] = "Checkout Free Instance";
    TrackingEventList["CHECKOUT_PAID"] = "Checkout Paid Instance";
    TrackingEventList["CLOUD_INVITE_USERS"] = "Cloud invite users";
    TrackingEventList["CONNECT_EXISTING"] = "Existing Instance Connected";
    TrackingEventList["CLOUD_PROFILE_COMPLETED"] = "Cloud profile completed";
    TrackingEventList["CLOUD_PROFILE_UPDATED"] = "Cloud profile updated";
    TrackingEventList["CLOUD_STORED_EDGES"] = "Cloud stored edges";
    TrackingEventList["CONNECT_TO_DATASOURCE"] = "Connect to datasource";
    TrackingEventList["DESIGNER_CREATE_DATA_SOURCE"] = "Designer create data source";
    TrackingEventList["DESIGNER_CREATE_PROJECT"] = "Designer create project";
    TrackingEventList["DESIGNER_DEFINE_RESOURCE_CSV"] = "Designer define resource csv";
    TrackingEventList["DESIGNER_DEFINE_RESOURCE_VIRTUAL"] = "Designer define resource virtual";
    TrackingEventList["DESIGNER_EXPORT_PROJECT"] = "Designer export project";
    TrackingEventList["DESIGNER_PUBLISH_PROJECT"] = "Designer publish project";
    TrackingEventList["EXPLORER_QUERY_BUILDER_EXECUTION"] = "Explorer query builder execution";
    TrackingEventList["EXPLORER_TEXT_BAR_SEARCH"] = "Explorer text bar search";
    TrackingEventList["KNOWLEDGE_KIT_USAGE"] = "Knowledge kit usage";
    TrackingEventList["KNOWLEDGE_CATALOG_ADD_DATA_CATALOG"] = "Knowledge catalog add data catalog";
    TrackingEventList["STUDIO_CREATE_DATA_SOURCE"] = "Studio create data source";
    TrackingEventList["STUDIO_CREATE_MODEL"] = "Studio create model";
    TrackingEventList["STUDIO_CREATE_USER"] = "Studio create user";
    TrackingEventList["STUDIO_CREATE_VIRTUAL_GRAPH"] = "Studio create virtual graph";
    TrackingEventList["STUDIO_EDIT_DATA_SOURCE"] = "Studio edit data source";
    TrackingEventList["STUDIO_EDIT_MODEL"] = "Studio edit model";
    TrackingEventList["STUDIO_EDIT_VIRTUAL_GRAPH"] = "Studio edit virtual graph";
    TrackingEventList["STUDIO_SPARQL_QUERY_EXECUTION"] = "Studio SPARQL query execution";
    TrackingEventList["VERIFICATION_MODAL_SEEN"] = "Verification modal seen";
    TrackingEventList["VOICEBOX_USAGE"] = "Voicebox usage";
})(TrackingEventList = exports.TrackingEventList || (exports.TrackingEventList = {}));
var ClientTypeList;
(function (ClientTypeList) {
    ClientTypeList["HUBSPOT"] = "hubspot";
})(ClientTypeList = exports.ClientTypeList || (exports.ClientTypeList = {}));
/** returns portal-sdk sdk object, or null if not in Portal */
const getPortalSdk = () => {
    const connectionCookie = (0, cookies_1.getConnectionCookie)();
    if (!connectionCookie) {
        return null;
    }
    const { graphqlEndpoint } = connectionCookie;
    if (!graphqlEndpoint) {
        return null;
    }
    const client = new graphql_request_1.GraphQLClient(graphqlEndpoint);
    const sdk = (0, sdk_1.getSdk)(client);
    return {
        addShare: (input) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield sdk.addShare({ input });
            return result.addShare || null;
        }),
        getConnectionByIndex: (index) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield sdk.getConnectionByIndex({ index });
            return result.connection || null;
        }),
        getVoiceboxConversation: (conversationId) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const result = yield sdk.getVoiceboxConversation({
                conversation_id: conversationId,
            });
            if (!result.getVoiceboxConversation) {
                return null;
            }
            return {
                id: result.getVoiceboxConversation.id,
                messages: ((_a = result.getVoiceboxConversation.message_history) === null || _a === void 0 ? void 0 : _a.filter((message) => message !== null)) || [],
            };
        }),
        listConnections: () => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield sdk.listConnections();
            if (!result.listConnections) {
                return null;
            }
            return result.listConnections.filter((connection) => connection !== null);
        }),
        listVoiceboxConversations: () => __awaiter(void 0, void 0, void 0, function* () {
            var _b;
            const result = yield sdk.listVoiceboxConversations();
            if (!result.listVoiceboxConversations) {
                return null;
            }
            return {
                conversations: result.listVoiceboxConversations.filter((conversation) => conversation !== null),
                count: ((_b = result.voiceboxConversationCount) === null || _b === void 0 ? void 0 : _b.count) || 0,
            };
        }),
        profile: () => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield sdk.profile();
            return result.profile || null;
        }),
        trackEvent: (input) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield sdk.trackEvent({ input });
            return result.trackEvent || null;
        }),
    };
};
exports.getPortalSdk = getPortalSdk;
